import { Text } from 'braid-design-system';
import React, { type ComponentProps } from 'react';

import TrackingLink from 'src/App/Components/TrackingLink/TrackingLink';
import type { AnalyticsTrackingData } from 'src/types';

import * as styles from './TrackingTextLookingLink.css';

type TextWeights = ComponentProps<typeof Text>['weight'];
type TextSizes = ComponentProps<typeof Text>['size'];

interface Props {
  displayText?: string | number;
  urlLink: string;
  target?: string;
  textWeight?: TextWeights;
  textSize?: TextSizes;
  maxLines?: number;
  trackingEventName: string;
  trackingActionOrigin?: string;
  trackingData?: AnalyticsTrackingData;
}

const TrackingTextLookingLink = ({
  urlLink,
  target,
  displayText,
  textWeight,
  textSize,
  maxLines,
  trackingEventName,
  trackingActionOrigin,
  trackingData,
}: Props) => (
  <TrackingLink
    href={urlLink}
    trackingEventName={trackingEventName}
    trackingActionOrigin={trackingActionOrigin}
    trackingData={trackingData}
    target={target}
  >
    <div className={styles.underlineText}>
      <Text
        maxLines={maxLines ? maxLines : 1}
        weight={textWeight}
        size={textSize}
      >
        <span className={styles.turnBlueOnHover}>{displayText}</span>
      </Text>
    </div>
  </TrackingLink>
);

export default TrackingTextLookingLink;
